import React, { useEffect, useState } from "react";
import FeaturedProduct from "../components/FeaturedProduct";
import { fetchProduct } from "../lib/api";
import useSeo from "../hooks/useSeo";

const ShopPage = () => {
  const [product, setProduct] = useState(null);

  useEffect(() => {
    fetchProduct().then(setProduct).catch(() => {});
  }, []);

  useSeo({
    title: "Shop · Football Grip Socks · 12 Colourways",
    description:
      "Shop the Pritch grip sock collection — 12 premium football colourways including Ice White, Mint Pitch, Bootroom Blue, Lavender Mist and Blackout White.",
    path: "/shop",
  });

  return (
    <div data-testid="shop-page">
      <section className="border-b border-line bg-chalk">
        <div className="container-x py-16 md:py-24">
          <p className="overline mb-4">Shop · Grip Socks</p>
          <h1 className="font-display uppercase text-5xl md:text-7xl tracking-tightest font-bold leading-[0.95]">
            The Series 01
            <br />
            <span className="text-mute">Collection.</span>
          </h1>
          <p className="mt-6 max-w-xl text-mute leading-relaxed">
            Twelve colourways. One technical fit. Premium football grip socks built for boot-lock fit,
            close touch and clean matchday style.
          </p>
        </div>
      </section>
      <FeaturedProduct product={product} />
    </div>
  );
};

export default ShopPage;
